import { Button } from '@99designs/common/components/Button';
import { ModalBody, ModalHeader } from '@99designs/common/components/Modal';
import { TabularMeta_User } from '__generated__/TabularMeta_User';
import { Color } from 'projects/consts';
import * as React from 'react';
import ColorComponent from './Color';
import Contacts from './Contacts';
import ContactsButton from './ContactsButton';
import { DrawerOverlay } from './DrawerOverlay';

interface Props {
    brief: {
        id: string;
        designers: TabularMeta_User[];
        contacts: TabularMeta_User[];
    };
}

interface State {
    showing: boolean;
}

class ContactsDrawer extends React.Component<Props, State> {
    state = {
        showing: false,
    };

    componentDidUpdate(prev: Props) {
        if (
            prev.brief.designers.length !== 0 &&
            this.props.brief.designers.length === 0 &&
            this.props.brief.contacts.length === 0
        ) {
            this.hideOverlay();
        }
    }

    hideOverlay = () => {
        this.setState({ showing: false });
    };

    showOverlay = () => {
        this.setState({ showing: true });
    };

    render() {
        const { showing } = this.state;
        const { brief } = this.props;

        return (
            <>
                <ContactsButton onClick={this.showOverlay} />
                <DrawerOverlay showing={showing} variations={['wide']} onClose={this.hideOverlay}>
                    <div className="contacts-drawer">
                        <ModalHeader>
                            <div className="heading heading--h3 heading--no-margin">
                                {__('Your contacts')}
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <Contacts brief={brief} />
                            <div className="contacts-drawer__done-cta">
                                <ColorComponent color={Color.createBlue}>
                                    <Button
                                        variations={[
                                            'primary',
                                            'nowrap',
                                            'responsive',
                                            'chameleon',
                                            'fluid',
                                        ]}
                                        onClick={this.hideOverlay}
                                    >
                                        {__('Confirm')}
                                    </Button>
                                </ColorComponent>
                            </div>
                        </ModalBody>
                    </div>
                </DrawerOverlay>
            </>
        );
    }
}

export default ContactsDrawer;
